import { MoovStepCustomerParametersDTO } from "./moovStepCustomerParametersDTO";

export class MoovStepDTO{
    public id!:number;
    public sequenceNo!:number;
    public description!:string;
    public moovStepDefinitionId!:number;
    public parameterOptionId?:number;
    public defaultParameters?:string;
    public customerParameters?:MoovStepCustomerParametersDTO;
    public inputFormatType?:string;
    public inputFormatId?:number;
    public outputFormatType?:string;
    public outputFormatId?:number;
    public canSkipIfNoData?:boolean;
    public canSkipAlways?:boolean;
    public prohibitDefaultParameterOverride?:boolean;
}